import {
  FileText,
  AlertTriangle,
  CheckCircle,
  DollarSign,
} from "lucide-react";
import React, { useState, useEffect } from "react";

const StatCards = ({
  currentPeriodData,
  trendsData,
  loading = false,
  onFilterChange,
  selectedFilter = "all",
}) => {
  const [filter, setFilter] = useState(selectedFilter);

  useEffect(() => {
    setFilter(selectedFilter);
  }, [selectedFilter]);

  const current = currentPeriodData || {};

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-[#131313] rounded-lg p-4 border-[#333333] border-2"
          >
            <div className="flex justify-between mb-2">
              <div className="h-4 bg-gray-700 rounded animate-pulse w-24"></div>
              <div className="w-8 h-8 bg-gray-700 rounded-full animate-pulse"></div>
            </div>
            <div className="h-8 bg-gray-700 rounded animate-pulse w-16 mb-2"></div>
            <div className="h-4 bg-gray-700 rounded animate-pulse w-20"></div>
          </div>
        ))}
      </div>
    );
  }

  // Handle filter change
  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    if (onFilterChange) {
      onFilterChange(newFilter); // Notify parent -> parent should fetch new data
    }
  };

  // Custom label for comparison text
  const comparisonLabel =
    filter === "all" ? "all time" : `last ${filter}`;

  return (
    <div>
      {/* Filter dropdown */}
      <div className="flex justify-end mb-4">
        <select
          value={filter}
          onChange={(e) => handleFilterChange(e.target.value)}
          className="bg-[#1f1f1f] text-gray-300 px-3 py-2 rounded-md text-sm font-medium border border-[#333333] focus:outline-none focus:ring-2 focus:ring-[#FFCA20]"
        >
          <option value="all">All Time</option>
          <option value="monthly">Monthly</option>
          <option value="quarterly">Quarterly</option>
          <option value="yearly">Yearly</option>
        </select>
      </div>

      {/* Stat cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {/* Total Applications */}
        <div className="bg-[#131313] rounded-lg p-4 border-[#333333] border-2">
          <div className="flex justify-between mb-2">
            <span className="text-gray-100 text-sm">TOTAL APPLICATIONS</span>
            <div className="bg-[#FFCA20] text-black w-8 h-8 rounded-full flex items-center justify-center">
              <FileText size={20} className="text-black" />
            </div>
          </div>
          <div className="text-2xl font-bold">
            {(current.totalApplications || 0).toLocaleString("en-IN")}
          </div>
          <div className="text-gray-400 text-sm mt-2">{comparisonLabel}</div>
        </div>

        {/* Pending Applications */}
        <div className="bg-[#131313] rounded-lg p-4 border-[#333333] border-2">
          <div className="flex justify-between mb-2">
            <span className="text-gray-100 text-sm">PENDING APPLICATIONS</span>
            <div className="bg-[#FFCA20] text-black w-8 h-8 rounded-full flex items-center justify-center">
              <AlertTriangle size={20} className="text-black" />
            </div>
          </div>
          <div className="text-2xl font-bold">
            {(current.pendingApplications || 0).toLocaleString("en-IN")}
          </div>
          <div className="text-gray-400 text-sm mt-2">{comparisonLabel}</div>
        </div>

        {/* Approved Loans */}
        <div className="bg-[#131313] rounded-lg p-4 border-[#333333] border-2">
          <div className="flex justify-between mb-2">
            <span className="text-gray-100 text-sm">APPROVED LOANS</span>
            <div className="bg-[#FFCA20] text-black w-8 h-8 rounded-full flex items-center justify-center">
              <CheckCircle size={20} className="text-black" />
            </div>
          </div>
          <div className="text-2xl font-bold">
            {(current.approvedApplications || 0).toLocaleString("en-IN")}
          </div>
          <div className="text-gray-400 text-sm mt-2">{comparisonLabel}</div>
        </div>
        {/* Approved Loans */}
        <div className="bg-[#131313] rounded-lg p-4 border-[#333333] border-2">
          <div className="flex justify-between mb-2">
            <span className="text-gray-100 text-sm">REJECTED LOANS</span>
            <div className="bg-[#FFCA20] text-black w-8 h-8 rounded-full flex items-center justify-center">
              <CheckCircle size={20} className="text-black" />
            </div>
          </div>
          <div className="text-2xl font-bold">
            {(current.rejectedApplications || 0).toLocaleString("en-IN")}
          </div>
          <div className="text-gray-400 text-sm mt-2">{comparisonLabel}</div>
        </div>

        {/* Loan Amount */}
        <div className="bg-[#131313] rounded-lg p-4 border-[#333333] border-2">
          <div className="flex justify-between mb-2">
            <span className="text-gray-100 text-sm">LOAN AMOUNT</span>
    <div className="bg-[#FFCA20] text-black w-8 h-8 rounded-full flex items-center justify-center">
      <span className="text-black font-bold text-lg opacity-80">₹</span>
    </div>
          </div>
          <div className="text-2xl font-bold">
            ₹{(current.totalLoanAmount || 0).toLocaleString("en-IN")}
          </div>
          <div className="text-gray-400 text-sm mt-2">{comparisonLabel}</div>
        </div>
      </div>
    </div>
  );
};

export default StatCards;
